import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import BackEndReportLayer from "../components/BackEndReportLayer";

const BackEndReportPage = () => {
  return (
    <MasterLayout>
      {/* <div className="breadcrumb-with-buttons mb-20">
        <div className="d-flex align-items-center justify-content-between">
          <h6 className="page-title mb-0">Back End Report</h6>
          <ul className="breadcrumb d-flex align-items-center gap-10">
            <li className="breadcrumb-item">
              <a href="#" className="text-secondary-light">
                Reports
              </a>
            </li>
            <li className="breadcrumb-item">
              <a href="#" className="text-secondary-light">
                Back End Report
              </a>
            </li>
          </ul>
        </div>
      </div> */}
      <BackEndReportLayer />
    </MasterLayout>
  );
};

export default BackEndReportPage;
